// Data sevice
import axios from 'axios'
import authHeader from './auth-header'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const API_URL = process.env.VUE_APP_API_URL;

class SectionsService {

    index() {
        return axios.get(API_URL + 'sections', { headers: authHeader() })
    }
    show(id) {
        return axios.get(API_URL + 'sections/' + id, { headers: authHeader() })
    }

    store(resource) {
        return axios.post(API_URL + 'sections', resource, { headers: authHeader() })
    }
    update(resource) {
        return axios.put(API_URL + 'sections/' + resource.id, resource, { headers: authHeader() })
    }
    delete(resource) {
        return axios.delete(API_URL + 'sections/' + resource.id, { headers: authHeader() })
    }
}

export default new SectionsService()